module.exports = __webpack_public_path__ + "static/media/s_sf_8.baa94052.png";